import { Delete, Save } from "@mui/icons-material";
import { Grid, IconButton, TextField } from "@mui/material";
import trash from "../../assets/sound/trash.mp3";
import React from "react";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import { Container } from "@mui/material";

const IphoneInvForm = ({
  id,
  title,
  setTitle,
  alterName,
  setAlterName,
  category,
  setCategory,
  barCode,
  setBarCode,
  store,
  setStore,
  van,
  setVan,
  web,
  setWeb,
  amazon,
  setAmazon,
  price,
  setPrice,
  cost,
  setCost,
  url,
  SetUrl,
  handleOnSubmit,
  buttonTitle,
}) => {
  const handleOnDelete = async () => {
    const userDoc = doc(db, "products", id);
    deleteDoc(userDoc);
    new Audio(trash).play();
  };

  return (
    <>
      <Grid container spacing={4}>
        {/* <Grid item xs={1} sm={12}>
          <TextField
            fullWidth
            type="text"
            color="primary"
            label="Title"
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </Grid> */}

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="text"
            color="primary"
            label="Store"
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            value={store}
            onChange={(e) => {
              setStore(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="text"
            color="primary"
            label="Van"
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            value={van}
            onChange={(e) => {
              setVan(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="text"
            color="primary"
            label="Web"
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            value={web}
            onChange={(e) => {
              setWeb(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type="text"
            color="primary"
            label="Amazon"
            autoComplete="off"
            InputLabelProps={{ shrink: true }}
            value={amazon}
            onChange={(e) => {
              setAmazon(e.target.value);
            }}
          />
        </Grid>

        <Grid
          item
          xs={1}
          sm={12}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <IconButton
            onClick={handleOnSubmit}
            variant="outlined"
            color="primary"
          >
            <Save sx={{ width: 30, height: 30 }} />
          </IconButton>

          <IconButton
            onClick={handleOnDelete}
            variant="outlined"
            color="secondary"
          ></IconButton>
        </Grid>
      </Grid>
    </>
  );
};

export default IphoneInvForm;
